<template>
  <div
    class="match flex"
    :class="`match-sport-color-${match.idSport}`">
    <div
      class="vertical-line"
      :class="`sport-color-${match.idSport}`"
    />
    <div class="grid-left">
      <match-header
        :id-match="match.id"
        :id-sport="match.idSport" />
      <match-teams
        :id-match="match.id"
        :id-sport="match.idSport"
      />
    </div>
    <div class="grid-right">
      <match-bets :match="match" />
    </div>
  </div>
</template>

<script>
import MatchHeader from './MatchHeader.vue';
import MatchTeams from './MatchTeams.vue';
import MatchBets from './MatchBets.vue';

export default {
  name: 'Match',
  components: {
    MatchHeader,
    MatchTeams,
    MatchBets,
  },
  props: {
    match: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match {
  position: relative;
  width: 100%;
  color: $color-text-primary;
  background-color: $match-color-back;
  border-bottom: 1px solid $color-border;
  height: 19vh;

  &:nth-child(2n) {
    .grid-right {
      background-color: $match-color-back-even;
    }
  }

  /deep/ .row {
    border: 0;
  }
}

.vertical-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: $match-vertical-line-width;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 1;
}

.grid-left {
  width: 38%;
}

.grid-right {
  position: relative;
  width: 62%;
}
</style>
